import './FileLink.scss';

export { default } from './FileLink';
